import { render, staticRenderFns } from "./WangEdit.vue?vue&type=template&id=cb4b6dd8&scoped=true&"
import script from "./WangEdit.vue?vue&type=script&lang=js&"
export * from "./WangEdit.vue?vue&type=script&lang=js&"
import style0 from "./WangEdit.vue?vue&type=style&index=0&id=cb4b6dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4b6dd8",
  null
  
)

export default component.exports